import React, { useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MainHeader } from "./MainHeader";
import { Footer } from "./MainFooter";
import { MainBody } from "./MainBody";
import Box from '@mui/material/Box';

function Main(props) {
  useEffect(() => {
    document.title = "Lynsis Event & Floral";
    const contentBody = document.getElementById("content-body");
    contentBody.addEventListener('scroll',
      throttle(() => {
        const topButton = document.getElementById("top-btn");
        const header = document.getElementById("lf-header");
        const scrollDistance = contentBody.scrollTop;
        const contentHeight = contentBody.offsetHeight;
        if (scrollDistance > contentHeight / 2) {
          topButton.classList.add("show-top-btn");
        } else {
          topButton.classList.remove("show-top-btn");
        }
        if (header) {
          header.classList.toggle("is-compact", scrollDistance > 20);
        }
      }, 150)
    )

    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          revealObserver.unobserve(entry.target);
        }
      });
    }, { root: contentBody, threshold: 0.12 });
    document.querySelectorAll(".lf-reveal").forEach((element) => {
      revealObserver.observe(element);
    });

    return () => {
      revealObserver.disconnect();
    };
  }, []);

  function throttle(callbackFn, limit) {
    let wait = false;
    return function () {
      if (!wait) {
        callbackFn.call();
        wait = true;
        setTimeout(() => {
          wait = false;
        }, limit);
      }
    }
  }

  return (
    <React.Fragment>
      <Box component='div' sx={{ position: 'relative', height: '100%' }}>
        <Box component='div' sx={{ position: 'absolute', top: 0, left: 0, right: 0, zIndex: 50 }}>
          <MainHeader />
        </Box>
        <Box component='div' sx={{ height: '100%', overflowY: 'auto', overflowX: 'hidden'}} id='content-body'>
          <MainBody />
          <Footer />
        </Box>
      </Box>
      <a id="top-btn" onClick={() => {
        const contentBody = document.getElementById("content-body");
        if (contentBody) {
          contentBody.scrollTo({ top: 0, behavior: 'smooth' })
        }
      }}>
        <FontAwesomeIcon icon='fa-solid fa-circle-arrow-up' />
      </a>
    </React.Fragment>
  );
}

export { Main };
